import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import type { SwiperOptions } from "swiper/types";
import { NavEntry } from "../../custom-stuff/etc/types";

type imageWithInfo = { image: string; info: string, relative_url?: string, question_fragment?: string, showInfo: boolean};


@Component({
    selector: "app-nav-with-image-carousel",
    templateUrl: "./nav-with-image-carousel.component.html",
    styleUrls: ["./nav-with-image-carousel.component.scss"],
    standalone: false
})
export class NavWithImageCarouselComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() imagesWithInfo: imageWithInfo[][];
  @Input() navLinks: NavEntry[];
	activeNavIndex: number;
  @ViewChild("mobileSwiper", { static: false }) mobileSwiperEl: ElementRef;
  @ViewChild("desktopSwiper", { static: false }) desktopSwiperEl: ElementRef;
	showMobileView: boolean;
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.showMobileView = event.target.innerWidth <= 800;
		setTimeout(() => this.initSwipers(), 0);
	}

	mobileNavLink: NavEntry;


  config: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 20,
		navigation: false,
  };

	mobileConfig: SwiperOptions = {
    slidesPerView: 1,
		navigation: false
	}

	get flattenedImageEntries(): imageWithInfo[] {
		let flattened = [];
		for (let imageEntry of this.navLinks[this.activeNavIndex].image_entries) {
			for (let image of imageEntry.images) {
				flattened.push(image);
			}
		}
		return flattened;

	}

	test(event) {
		this.activeNavIndex = this.navLinks.indexOf(event.value)

	}

	changeActiveNavIndex(i: number) {
		this.activeNavIndex = i;
		console.log(this.activeNavIndex);
		console.log(this.navLinks[this.activeNavIndex])

	}

  constructor() {}

  ngOnInit(): void {
		this.showMobileView = window.innerWidth <= 800;
		this.activeNavIndex = 0
		console.log(this.navLinks);
	}

	ngOnChanges(changes: SimpleChanges) {
		let info = changes["imagesWithInfo"]
		let navLinks = changes["navLinks"]
		if (info && info.currentValue) {
		console.log("nav with image carousel")
			console.log(info.currentValue);
		}
		if (navLinks && navLinks.currentValue) {
			this.mobileNavLink = navLinks.currentValue[0];
		}

	}


  ngAfterViewInit(): void {
    this.initSwipers();
  }

  private initSwipers(): void {
    if (this.mobileSwiperEl?.nativeElement && !this.mobileSwiperEl.nativeElement.swiper) {
      Object.assign(this.mobileSwiperEl.nativeElement, this.mobileConfig);
      this.mobileSwiperEl.nativeElement.initialize();
    }
    if (this.desktopSwiperEl?.nativeElement && !this.desktopSwiperEl.nativeElement.swiper) {
      Object.assign(this.desktopSwiperEl.nativeElement, this.config);
      this.desktopSwiperEl.nativeElement.initialize();
    }
  }

  slideNext(): void {
    const el = this.showMobileView ? this.mobileSwiperEl : this.desktopSwiperEl;
    el?.nativeElement?.swiper?.slideNext();
  }
  slidePrev(): void {
    const el = this.showMobileView ? this.mobileSwiperEl : this.desktopSwiperEl;
    el?.nativeElement?.swiper?.slidePrev();
  }
}
